import { useState } from "react";

import { EMPTY_STAGED_SEARCH, StagedSearch } from "./term-builder";

/** Exported for test only */
export const useStaged = () => useState<StagedSearch>(EMPTY_STAGED_SEARCH);
